import { render } from "./DemandForecastingSettingsForecasting.vue?vue&type=template&id=7dd4cf17&scoped=true"
import script from "./DemandForecastingSettingsForecasting.vue?vue&type=script&lang=js"
export * from "./DemandForecastingSettingsForecasting.vue?vue&type=script&lang=js"

import "./DemandForecastingSettingsForecasting.vue?vue&type=style&index=0&id=7dd4cf17&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd4cf17"]])

export default __exports__